<div class="main-content table-page ajustes-page proyecto-pagina">
  <div class="container-fluid">
    <nav class="app-migas" aria-label="Ruta de navegación">
      <a [routerLink]="rutaLista">Gestión de proyectos</a>
      <span class="material-icons app-migas__separador" aria-hidden="true">chevron_right</span>
      <span aria-current="page">{{ proyecto?.nombre || "Proyecto" }}</span>
    </nav>

    <section class="ajustes-card" *ngIf="cargando && !proyecto">
      <div class="ajustes-card__body proyecto-pagina__estado">
        <span class="material-icons" aria-hidden="true">hourglass_top</span>
        <h1>Consultando el proyecto</h1>
        <p>Espere un momento.</p>
      </div>
    </section>

    <section class="ajustes-card" *ngIf="!cargando && error">
      <div class="ajustes-card__body proyecto-pagina__estado">
        <span class="material-icons" aria-hidden="true">folder_off</span>
        <h1>No se pudo mostrar el proyecto</h1>
        <p>{{ error }}</p>
        <div class="proyecto-pagina__estado-acciones">
          <a class="app-form-btn app-form-btn--secondary app-form-btn--compact" [routerLink]="rutaLista">Ir a Gestión de proyectos</a>
          <button type="button" class="app-form-btn app-form-btn--primary app-form-btn--compact" (click)="cargar()">Volver a intentar</button>
        </div>
      </div>
    </section>

    <ng-container *ngIf="proyecto as p">
      <!-- Encabezado: lo de la tarjeta (nombre, estatus, cliente, ID, responsable y planeación) y las pestañas. -->
      <section class="ajustes-card proyecto-pagina__cabeza">
        <div class="proyecto-pagina__identidad">
          <div class="proyecto-pagina__titulo">
            <div class="proyecto-pagina__nombre">
              <h1>{{ p.nombre || "Sin nombre" }}</h1>
              <span class="table-page__status-badge" *ngIf="p.uiStatus" [ngClass]="p.uiStatusClass">{{ p.uiStatus }}</span>
            </div>
            <p>{{ p.nombreCliente || "Sin cliente" }}</p>
          </div>
          <button type="button" class="app-form-btn app-form-btn--secondary app-form-btn--compact" (click)="editarProyecto()">
            <span class="material-icons" aria-hidden="true">edit</span>
            Editar proyecto
          </button>
        </div>

        <div class="proyecto-pagina__datos">
          <div class="app-dato-caja">
            <span class="app-dato-caja__etiqueta">ID Proyecto</span>
            <strong class="app-dato-caja__valor">{{ p.idProyecto || "—" }}</strong>
          </div>
          <div class="app-dato-caja">
            <span class="app-dato-caja__etiqueta">Responsable</span>
            <strong class="app-dato-caja__valor">{{ p.nombreLider || "Sin responsable" }}</strong>
          </div>
          <div class="app-dato-caja">
            <span class="app-dato-caja__etiqueta">Planeación</span>
            <strong class="app-dato-caja__valor">{{ p.uiDateRange }}</strong>
          </div>
        </div>

        <nav class="areas-tabs proyecto-pagina__pestanas" aria-label="Secciones del proyecto">
          <a *ngFor="let t of pestanas; trackBy: trackPestana" class="areas-tabs__t" [class.is-on]="pestana === t.clave"
             [attr.aria-current]="pestana === t.clave ? 'page' : null"
             [routerLink]="[]" [queryParams]="{ pestana: t.clave }" queryParamsHandling="merge">
            <span class="material-icons" aria-hidden="true">{{ t.icono }}</span>
            {{ t.texto }}
            <span class="proyecto-pagina__cuenta" *ngIf="t.clave === 'etapas' && totalEtapas">{{ totalEtapas }}</span>
          </a>
        </nav>
      </section>

      <!-- Cada pestaña se monta al entrar (A1 y riesgos consultan al servidor). -->
      <app-proyecto-resumen *ngIf="pestana === 'resumen'" [proyecto]="p" [severidad]="severidad" [totalDefectos]="totalDefectos">
      </app-proyecto-resumen>

      <app-etapas-versiones *ngIf="pestana === 'etapas'" [idProyecto]="idProyecto" [nombreProyecto]="p.nombre"
                            [estatusProyecto]="p.estatus" [claveSeleccionada]="claveEtapa" (elegirEtapa)="elegirEtapa($event)"
                            (crearEtapa)="editarEtapa(null)" (editarEtapa)="editarEtapa($event)">
      </app-etapas-versiones>

      <section class="table-page__card" *ngIf="pestana === 'seguimientos'" aria-labelledby="proyecto-pagina-seguimientos">
        <div class="proyecto-pagina__tabla-cabeza">
          <h2 id="proyecto-pagina-seguimientos" class="proyecto-pagina__subtitulo">
            <span class="material-icons" aria-hidden="true">forum</span>
            Historial de avances
          </h2>
          <button type="button" class="app-form-btn app-form-btn--primary app-form-btn--compact" (click)="agregarSeguimiento()">
            <span class="material-icons" aria-hidden="true">track_changes</span>
            Agregar seguimiento
          </button>
        </div>

        <div class="table-page__table-wrap" *ngIf="seguimientos.length; else sinSeguimientos">
          <table class="table-page__table">
            <caption class="cdk-visually-hidden">Seguimientos del proyecto {{ p.nombre }}</caption>
            <thead>
              <tr>
                <th scope="col">Fecha</th>
                <th scope="col">Autor</th>
                <th scope="col">Comentario</th>
                <th scope="col">Avance</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let seguimiento of seguimientos; trackBy: trackSeguimiento">
                <td class="proyecto-pagina__fecha">{{ seguimiento.fecha || "—" }}</td>
                <td>{{ seguimiento.nombreUsuario || "—" }}</td>
                <td class="proyecto-pagina__comentario">{{ seguimiento.descripcion || "Sin comentario" }}</td>
                <td>{{ seguimiento.porcentajeRegistrado ?? 0 }} %</td>
              </tr>
            </tbody>
          </table>
        </div>

        <ng-template #sinSeguimientos>
          <div class="table-page__empty">
            <span class="material-icons" aria-hidden="true">forum</span>
            <strong>No se han registrado actualizaciones</strong>
            <span>Registre el primer seguimiento con «Agregar seguimiento».</span>
          </div>
        </ng-template>
      </section>

      <ng-container *ngIf="pestana === 'riesgos'">
        <div class="proyecto-pagina__acciones">
          <button type="button" mat-raised-button class="btn table-page__icon-btn table-page__icon-btn--secondary" (click)="agregarRiesgo()">
            <span class="material-icons" aria-hidden="true">warning</span>
            <span>Agregar riesgo</span>
          </button>
        </div>
        <app-consulta-riesgo [proyectoSeleccionado]="p" (mostrarPrincipal)="irALista()"></app-consulta-riesgo>
      </ng-container>
    </ng-container>
  </div>
</div>
